import { createApp } from 'vue'
import App from './App.vue'
import Layui from '@layui/layui-vue'
import '@layui/layui-vue/lib/index.css'
// import C0001Main from "@/components/C0001/C0001Main";


createApp(App).use(Layui).mount('#app')
